<template>
  <div>
    <v-card-text>
      <v-autocomplete
        v-if="this.codChaptersOptions !== null"
        v-model="selectedCodChapters"
        :items="translateCodChapters"
        chips
        multiple
        clearable
        deletable-chips
        :label="this.$i18n.tc('cod_2012_chapter', 2)"
        @change="codChoice()"
      >
      </v-autocomplete>
      <v-autocomplete
        v-if="
          this.codSubChaptersOptions !== null &&
            this.selectedCodChapters !== null &&
            this.selectedCodChapters.length > 0
        "
        v-model="selectedCodSubChapters"
        :items="translateCodSubChapters"
        chips
        multiple
        clearable
        deletable-chips
        :label="this.$i18n.tc('cod_2012_subchapter', 2)"
        @change="codChoice()"
      >
      </v-autocomplete>
      <v-alert
        type="info"
        color="info"
        outlined
      >
        {{ this.$t("alert.cod_shortlist_version.part_1") }}
        <a
          :href="this.$t('cod_2012.src')"
          :title="this.$t('cod_2012.src')"
          target="_blank"
          class="warning--text"
          >{{ this.$t("cod_2012.label") }}
          <v-icon small color="warning">{{ mdiOpenInNew }}</v-icon>
        </a>
        {{ this.$t("alert.cod_shortlist_version.part_2") }}
        <a
          :href="this.$t('cod_1998.src')"
          :title="this.$t('cod_1998.src')"
          target="_blank"
          class="warning--text"
          >{{ this.$t("cod_1998.label") }}
          <v-icon small color="warning">{{ mdiOpenInNew }}</v-icon>
        </a>
        {{ this.$t("alert.cod_shortlist_version.part_3") }}
      </v-alert>
    </v-card-text>
  </div>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";
import axios from "axios";
export default {
  name: "EurostatCodForm",
  components: {},
  props: {
    lang: {
      type: String,
      required: true,
      default: "fr-FR"
    }
  },
  data: function() {
    return {
      codChaptersOptions: null,
      codSubChaptersOptions: null,
      error: null,
      mdiOpenInNew: mdiOpenInNew,
      selectedCodChapters: null,
      selectedCodSubChapters: null
    };
  },
  computed: {
    translateCodChapters: function() {
      const val = this;
      const res = Object.keys(this.codChaptersOptions).map(function(e) {
        return {
          value: val.codChaptersOptions[e],
          text:
            ". ".repeat(val.codChaptersOptions[e].level - 1) +
            val.codChaptersOptions[e].code +
            " " +
            val.codChaptersOptions[e].label
        };
      });
      return res;
    },
    translateCodSubChapters: function() {
      const val = this;
      const res = Object.keys(this.codSubChaptersOptions).map(function(e) {
        return {
          value: val.codSubChaptersOptions[e],
          text:
            val.codSubChaptersOptions[e].code +
            " " +
            val.codSubChaptersOptions[e].label
        };
      });
      return res;
    },
    selectedCod: function() {
      if (this.selectedCodChapters !== null) {
        if (this.selectedCodChapters.length > 0) {
          const val = this;
          if (this.codSubChaptersOptions !== null) {
            if (this.selectedCodSubChapters !== null) {
              if (this.selectedCodSubChapters.length > 0) {
                // checking if selected codes in subchapters codes options
                let res = [];
                // BOUCLE SUR LES SOUS-CHAPITRES SELECTIONNES
                // si ces sous-chapitres font partie des options possibles, alors on les ajoute à la sélection
                for (let key in Object.keys(this.selectedCodSubChapters)) {
                  if (
                    Object.keys(this.codSubChaptersOptions)
                      .map(function(e) {
                        return val.codSubChaptersOptions[e].code;
                      })
                      .includes(this.selectedCodSubChapters[key].code)
                  ) {
                    res.push(this.selectedCodSubChapters[key].code);
                  }
                }
                // pour chaque élément de selectedCodChapters,
                // SI son code Eurostat ne fait pas partie de 'res'
                // ET qu'aucun élément de res n'a le même num1, alors on l'ajoute à res avec res.push
                // BOUCLE SUR LES CHAPITRES SELECTIONNES
                for (let key in Object.keys(this.selectedCodChapters)) {
                  // le chapitre ne fait en revanche des sous-chapitres sélectionnées (2e menu déroulant) ?
                  if (!res.includes(this.selectedCodChapters[key].code)) {
                    // est-ce qu'aucun sous-chapitre de ce chapitres a été sélectionné ?
                    if (
                      !Object.keys(this.selectedCodSubChapters)
                        .map(function(e) {
                          return val.selectedCodSubChapters[e].num1;
                        })
                        .includes(this.selectedCodChapters[key].num1)
                    ) {
                      res.push(this.selectedCodChapters[key].code);
                    }
                  }
                }
                return res;
              } else {
                return Object.keys(this.selectedCodChapters).map(function(e) {
                  return val.selectedCodChapters[e].code;
                });
              }
            } else {
              return Object.keys(this.selectedCodChapters).map(function(e) {
                return val.selectedCodChapters[e].code;
              });
            }
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  },
  methods: {
    availableCodChapters: function() {
      this.error = false;
      const val = this;
      axios
        .get("bcmd/r/codes", {
          params: {
            level: ["1"],
            lang: val.$i18n.locale
          }
        })
        .then(response => {
          this.codChaptersOptions = response.data;
          this.selectedCodChapters = null;
        })
        .catch(() => {
          this.error = true;
        });
    },
    availableCodSubChapters: function() {
      this.error = false;
      const val = this;
      if (this.selectedCodChapters !== null) {
        if (this.selectedCodChapters.length > 0) {
          axios
            .get("bcmd/r/codes_num1", {
              params: {
                code: Object.keys(this.selectedCodChapters).map(function(e) {
                  return val.selectedCodChapters[e].code;
                }),
                lang: val.$i18n.locale
              }
            })
            .then(response => {
              this.codSubChaptersOptions = response.data;
            })
            .catch(() => {
              this.error = true;
            });
        } else {
          this.codSubChaptersOptions = null;
        }
      } else {
        this.codSubChaptersOptions = null;
      }
    },
    codChoice: function() {
      // todo : remove this method ?
      console.log("@codChoice -- this.selectedCod :");
      //console.log(this.selectedCod);
      return true;
    }
  },
  beforeMount() {
    this.availableCodChapters();
  },
  watch: {
    $props: {
      handler: function() {
        console.log("watch handler");
        this.availableCodChapters();
        this.availableCodSubChapters();
        this.codChoice();
      },
      deep: true
    },
    selectedCodChapters: function() {
      this.availableCodSubChapters();
    },
    selectedCod: function() {
      console.log("watch selectedCod : $emit update-cod");
      this.$emit("update-cod", this.selectedCod);
    }
  }
};
</script>
